import React, { CSSProperties } from "react";
import cx from "classnames";
import styles from "./fieldset-footer-status.module.scss";

export interface IFieldsetFooterStatus {
  children?: React.ReactNode;
  className?: string;
  style?: CSSProperties;
  htmlId?: string;
}

export const FieldsetFooterStatus = (props: IFieldsetFooterStatus) => {
  return (
    <div className={cx(styles.fieldset_footer_status, props.className)} style={props.style} id={props.htmlId}>
      {props.children}
    </div>
  );
};

FieldsetFooterStatus.defaultProps = {};
